import React from "react";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

// Institution '02' has no group concept, so nothing is rendered for it.
export default function GroupSelect({ userInst, group, onChange, required, error, isWinter = true }) {
    if (userInst !== '01') {
        return null;
    }

    return (
        <FormControl sx={{ width: '100%', mb: 2.5 }} size="small" required={required} error={error}>
            <Typography sx={{ mb: 0.5, color: '#17233D', fontSize: 15, fontWeight: 500 }}>
                Gruppe <span style={{ color: isWinter ? '#439AC2' : '#7FAF84' }}>*</span>
            </Typography>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={group}
                label=""
                onChange={onChange}
                sx={{
                    height: 48,
                    minHeight: 48,
                    color: '#17233D',
                    fontSize: 16,
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            mt: 0.75,
                            border: `2px solid ${isWinter ? '#9FC8DA' : '#B6D0B8'}`,
                            borderRadius: '12px',
                            boxShadow: '0 12px 28px rgba(15, 23, 42, 0.16)',
                            '& .MuiMenuItem-root': {
                                minHeight: 40,
                                px: 2,
                                color: '#17233D',
                                fontSize: 15,
                                borderRadius: '8px',
                                mx: 0.5,
                            },
                            '& .MuiMenuItem-root:hover': {
                                backgroundColor: isWinter ? '#F1FAFD' : '#F1F8F1',
                            },
                            '& .MuiMenuItem-root.Mui-selected': {
                                backgroundColor: isWinter ? '#E5F5FA' : '#E8F3E8',
                                fontWeight: 600,
                            },
                            '& .MuiMenuItem-root.Mui-selected:hover': {
                                backgroundColor: isWinter ? '#D9F0F7' : '#DDEDDD',
                            },
                        },
                    },
                }}
            >
                <MenuItem value={"2C"}>2C</MenuItem>
                <MenuItem value={"2D"}>2D</MenuItem>
                <MenuItem value={"2E"}>2E</MenuItem>
                <MenuItem value={"1A"}>1A</MenuItem>
                <MenuItem value={"1B"}>1B</MenuItem>
                <MenuItem value={"TEST"}>TEST</MenuItem>
            </Select>
        </FormControl>
    );
}
